import template from './brand.html';
import controller from './brand.controller';

let brandComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default brandComponent;
